import { Controller } from "@hotwired/stimulus";
import Tabulator from "../lib/tabulator";

export default class extends Controller {
  connect() {
    const tableEl =
      this.element.tagName === "TABLE"
        ? this.element
        : this.element.querySelector("table");
    if (!tableEl) return;

    this.tableEl = tableEl;
    const rows = this.parseRows();
    const columns = this.buildColumns();

    this.tabulator = new Tabulator(tableEl, {
      data: rows,
      columns: columns,
      layout: "fitColumns",
    });
  }

  disconnect() {
    this.tabulator?.destroy();
  }

  parseRows() {
    return Array.from(this.tableEl.querySelectorAll("tbody tr")).map((row) => {
      const obj = {};
      Array.from(row.querySelectorAll("td")).forEach((td, i) => {
        obj[`c${i}`] = td.innerHTML;
      });
      return obj;
    });
  }

  buildColumns() {
    return Array.from(this.tableEl.querySelectorAll("thead th")).map((th, i) => {
      const col = {
        title: th.textContent.trim(),
        field: `c${i}`,
        formatter: "html",
        hozAlign: th.classList.contains("text-end") ? "right" : "left",
        headerHozAlign: th.classList.contains("text-end") ? "right" : "left",
      };

      if (i === 0) {
        col.headerSort = false;
        col.widthGrow = 3;
      } else {
        col.widthGrow = 1;
      }

      if (i === 1) {
        col.headerFilter = "list";
        col.headerFilterParams = {
          values: {
            "": "All",
            budget: "Budget",
            casual: "Casual",
            tournament: "Tournament",
          },
          clearable: true,
        };
      }

      return col;
    });
  }
}
